import { render, staticRenderFns } from "./DeletedJobs.vue?vue&type=template&id=600518d5&"
import script from "./DeletedJobs.vue?vue&type=script&lang=js&"
export * from "./DeletedJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports